var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCompassBlueCircle = function SvgCompassBlueCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#E6F4FF",
    rx: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#compass-blue-circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 28.333a8.333 8.333 0 1 0 0-16.666 8.333 8.333 0 0 0 0 16.666Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.268 16.888c.407-.135.61-.203.746-.155.118.042.21.135.253.252.048.136-.02.34-.156.747l-1.24 3.719c-.038.115-.057.173-.09.221a.418.418 0 0 1-.109.11c-.048.032-.106.051-.222.09l-3.719 1.24c-.407.135-.61.203-.746.155a.417.417 0 0 1-.252-.252c-.049-.136.02-.34.155-.747l1.24-3.718c.038-.116.058-.174.09-.223a.416.416 0 0 1 .11-.108c.047-.033.105-.052.221-.091l3.719-1.24Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "compass-blue-circle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 10h20v20H10z"
  })))));
};
export default SvgCompassBlueCircle;